export const environment = {
    URL: 'https://www.leoprime.com/',
    CC_URL: 'https://cc.leoprime.com/',
    ANALYSIS_URL: 'https://analysis.leoprime.com/',
    STAGING_URL: 'https://cc.leoprime.com/',
};
